import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" minHeight="100vh" textAlign="center">
      <Typography variant="h3" gutterBottom>404 – Page Not Found</Typography>
      <Typography variant="body1" gutterBottom>
        The page you're looking for doesn’t exist or has been moved.
      </Typography>
      <Button variant="contained" color="primary" onClick={() => navigate("/login")}>
        Go to Login
      </Button>
    </Box>
  );
};

export default NotFoundPage;